<ng-container *transloco="let convert;">
  <div
    data-test-id="address-change-modal-container"
    class="modal micromodal-slide"
    [attr.id]="modalId"
    aria-hidden="true"
    tabindex="-1"
    role="dialog"
    aria-labelledby="dialog-child-name"
    >
    <div class="modal__overlay" tabindex="-1">
      <div
        class="modal__container modal--address-change"
        role="dialog"
        aria-modal="true"
        aria-labelledby="address-change-modal-title"
        data-track-region="Address change modal"
        >
        <header class="modal__header">
          <h1 data-test-id="address-change-modal-title" class="text-brand" id="offer-modal-title" tabindex="-1">
            {{convert('profileManagement.addressChangeModal.request')}} @if (isPhysical) {
            {{convert('profileManagement.addressChangeModal.physical')}}
          }
          @if (isTitle) {
            {{convert('profileManagement.addressChangeModal.title')}}
            } {{convert('profileManagement.addressChangeModal.addressChange')}}
          </h1>
        </header>

        <div class="modal__content">
          <div class="modal__body">
            <p data-test-id="address-change-modal-description">
              @if (isPhysical) {
                {{convert('profileManagement.addressChangeModal.textUpdatePhysical')}}
              }
              @if (isTitle) {
                {{convert('profileManagement.addressChangeModal.textUpdateTitle')}}
              }
            </p>
          </div>
          <app-address-change-form
            data-test-id="address-change-modal-form"
            [variant]="variant"
            (closed)="closeModal()"
            (updated)="closeModal(); success.emit();"
            (sendError)="receiveError($event)"
            #addressChangeForm
          ></app-address-change-form>
        </div>

        <button
          data-test-id="address-change-modal-close-btn"
          data-track-elem="button"
          data-track-name="Close"
          data-track-trigger="close"
          class="modal__close"
          [attr.aria-label]="convert('common.modalClose')"
          (click)="closeModal(); resetForm()"
          >
          <img
            data-test-id="address-change-modal-close-icon"
            src="../../../ui/assets/assets-{{ configuration.tenantName }}/{{ configuration.tenantName }}-close.svg"
            alt="{{convert('common.altCloseModelIcon')}}"
            />
        </button>
      </div>
    </div>
  </div>
</ng-container>
